import { FlightProduct, SeatingProduct } from '@/api/Cart/cart.interfaces';
import flatten from 'lodash/flatten';
import { Money } from '@libs/money/money.interfaces';
import { GordianResponse } from '@/components/shared/GordianSeatMap/Gordian.interfaces';
import { isUsingFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';
import { t } from '@shared/helpers/translation';
import { Market } from '@shared/config/market/market.models';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';

const market: Market = getCurrentMarketSpecs();
const Currency = market.moneyFormat.currency;

export const VISIBLE_BOOKING_FEE_CARRIERS: readonly string[] = ['AF', 'KL'];

export const getAllSeatsForFlightProduct = (flightProduct: FlightProduct): SeatingProduct[] =>
    flatten(flightProduct.Pax.map((pax) => pax?.SelectedSeats || []));

export const getSeatingTotalPriceForFlightProduct = (
    flightProduct: FlightProduct
): Money | null =>
    getSeatingTotalPriceForAllProducts(getAllSeatsForFlightProduct(flightProduct));

export const getSeatingTotalPriceForAllProducts = (seats: SeatingProduct[]): Money | null => {
    const totalPrice = (seats || []).reduce(
        (accumulated, { Price }) => ({
            Amount: accumulated.Amount + Price.Amount,
            Currency: Price.Currency,
        }),
        { Amount: 0, Currency: '' }
    );

    return totalPrice.Amount ? totalPrice : null;
};

export const getSeatDescription = (seat: SeatingProduct) => {
    return seat.Description
        ? seat.Description
        : `${t({ key: 'seating.seat' })}: ${seat.Row}${seat.Column}`;
};

export const formatGordianBasketResponse = (
    gordianResponse: GordianResponse
): SeatingProduct[] => {
    return isUsingFakeData()
        ? fakeDataSeats
        : Object.values(gordianResponse.basket).map((s) => ({
              Column: s.product_details.column,
              Row: s.product_details.row,
              Description: s.display_name,
              Id: s.basket_item_id,
              Price: {
                  Amount: s.price.total.amount / Math.pow(10, s.price.total.decimal_places),
                  Currency: s.price.total.currency,
              },
              PriceBreakdown: null,
          }));
};

const fakeDataSeats: SeatingProduct[] = [
    {
        Column: 'A',
        Row: 10,
        Description: 'Seat: 10A, SK 884',
        Id: '1d41ab13-3831-4da1-a605-5e004374d6d59',
        Price: {
            Amount: 218.45,
            Currency,
        },
        PriceBreakdown: {
            SupplierPrice: {
                Amount: 140,
                Currency,
            },
            TotalPrice: {
                Amount: 208.45,
                Currency,
            },
            BookingFee: {
                Amount: 48.45,
                Currency,
            },
        },
    },
    {
        Column: 'B',
        Row: 10,
        Description: 'Seat: 10B, SK 884',
        Id: '1d41ab13-3831-4da1-a605-5e004374d6d5',
        Price: {
            Amount: 208.45,
            Currency,
        },
        PriceBreakdown: {
            SupplierPrice: {
                Amount: 150,
                Currency,
            },
            TotalPrice: {
                Amount: 208.45,
                Currency,
            },
            BookingFee: {
                Amount: 58.45,
                Currency,
            },
        },
    },
];
